/* eslint-disable import/no-cycle */
import { css, html, nothing, PropertyValues } from 'lit';
import { ifDefined } from 'lit-html/directives/if-defined.js';
import { property, query, state } from 'lit/decorators.js';
import { BaseElement } from '../../components/base-element/base-element';
import { customElement } from '../../components/base-element/decorators/customElement';
import { TreeItemWC } from '../../components/tree-item/tree-item.wc';
import { Org, OrgWithChildren } from './types';

import '../../components/avatar/avatar.wc';
import '../../components/icon/icon.wc';

@customElement('ps-universal-nav-tree-child')
export class ChildTreeItemWC extends BaseElement {
  static styles = css`
    :host {
      display: contents;
    }
  `;

  @property({ type: Object }) child: OrgWithChildren | Org;

  @property({ type: String }) orgId: string | undefined;

  @property({ type: Boolean }) isDisabled: boolean = false;

  @property({ type: Boolean }) isSmartMenuEnabled: boolean = false;

  @query('ps-tree-item') treeItem: TreeItemWC;

  createRenderRoot() {
    return this;
  }

  render() {
    const childImage = this.child.pictureFile?.url;
    const defaultOrgImage = html`<ps-avatar
      size="msmall"
      label=${`${this.child.name?.split(' ')[0]}`}
      shape="square"
      slot="prefix"
    ></ps-avatar>`;

    return html`
      <ps-tree-item
        level=${ifDefined(this.child.depth)}
        ?selected=${this.child.id === this.orgId}
        data-org-id=${ifDefined(this.child.id)}
        @click=${() => !this.isDisabled && this.emit('menu-item-selected')}
        ?disabled=${this.isDisabled}
        expanded
      >
        ${childImage
          ? html`<ps-image
              width="20"
              height="20"
              src=${childImage}
              radius="small"
              slot="prefix"
            >
              <slot slot="fallbackImage"> ${defaultOrgImage} </slot>
            </ps-image>`
          : defaultOrgImage}
        ${this.child.name}
        ${(this.child.children || []).map((item: OrgWithChildren | Org) =>
          item.visible || !this.isSmartMenuEnabled
            ? html`<ps-universal-nav-tree-child
                .child=${item}
                slot="children"
                orgId=${ifDefined(this.orgId)}
                ?isDisabled=${this.isDisabled}
                ?isSmartMenuEnabled=${this.isSmartMenuEnabled}
              ></ps-universal-nav-tree-child>`
            : nothing
        )}
      </ps-tree-item>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'ps-universal-nav-tree-child': ChildTreeItemWC;
  }
  enum PSElementTagNameMap {
    'ps-universal-nav-tree-child' = 'ps-universal-nav-tree-child',
  }
}
